import React from 'react';
import { createRoot } from 'react-dom/client';
import { LegalInformation } from '../main-app/components/LegalInformation/LegalInformation';

const SchoolLegalInformationEntry = ({ node }) => {
  if (!node) return;

  const siretNumber = node.getAttribute('data-siret-number');
  const establishmentNumber = node.getAttribute('data-establishment-number');
  const ndaNumber = node.getAttribute('data-nda-number');

  const root = createRoot(node);
  root.render(
    <LegalInformation
      siretNumber={siretNumber}
      establishmentNumber={establishmentNumber}
      ndaNumber={ndaNumber}
    />,
  );
};

export default SchoolLegalInformationEntry;
